/**
 * @author Maxime Louf
 * @version 1.0
 *
 * @super Disclosure
 * @export {Accordion}
 */

import { Disclosure } from './Disclosure';

export class Accordion extends Disclosure {
    static allInstances = [];

    constructor(trigger) {
        super(trigger, { outsideClick: false });
        this.button = trigger;
        this.triggerArray = [];
        this.panel = document.getElementById(this.button.getAttribute('aria-controls'));

        const toggleList = document.querySelectorAll('.js-accordion');
        // All triggers
        this.triggerArray.push(...toggleList);

        // Les éléments avec le même "name" seront lié et un seul élément pourra être affiché à la fois
        this.name = this.button.getAttribute('data-name');

        if (this.name) {
            this.triggerArrayFilteredByName = this.triggerArray.filter((e) => e.getAttribute('data-name') === this.name);
        }

        // Toutes les initialisations de la classe Accordion sont stockée ici
        Accordion.allInstances.push(this);
    }

    show() {
        let activeSiblings = [];

        super.show();

        // Si des éléments sont lié avec un "name"
        if (this.name) {
            // find active siblings
            activeSiblings = this.triggerArrayFilteredByName
                // On retire le trigger courant
                .filter((trigger) => trigger !== this.trigger);

            // hide active siblings
            Accordion.allInstances.forEach((instance) => {
                activeSiblings.forEach((activeSibling) => {
                    if (instance.button === activeSibling) {
                        instance.hide();
                    }
                });
            });
        }
    }

    hide() {
        super.hide();
    }

    init() {
        super.init();

        if (this.name) {
            this.triggerArrayFilteredByName.forEach((item, index) => {
                // Ajouter un événement de clavier pour la navigation par flèches
                item.addEventListener('keydown', (e) => this.handleKeyDown(e, index));
            });
        }
    }

    // Gestion des touches de navigation haut et bas
    handleKeyDown(event, index) {
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.navigate(1, index); // Aller à l'élément suivant
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            this.navigate(-1, index); // Aller à l'élément précédent
        }
    }

    // Fonction de navigation entre les items
    navigate(direction, currentIndex) {
        let newIndex = currentIndex + direction;

        // Si on dépasse les limites, on boucle
        if (newIndex < 0) {
            newIndex = this.triggerArrayFilteredByName.length - 1; // Aller au dernier élément
        } else if (newIndex >= this.triggerArrayFilteredByName.length) {
            newIndex = 0; // Aller au premier élément
        }

        // Déplacer le focus sur le nouvel élément
        this.triggerArrayFilteredByName[newIndex].focus();
    }

    destroy() {
        super.destroy();
        const i = Accordion.allInstances.indexOf(this);
        Accordion.allInstances.splice(i, 1);
    }
}
